import {selectHasCapability} from 'utils/ropProgram';
import {API} from 'config/employer.config';
import {mergeInstanceData} from 'redux/modules/auth/actions';
import {getLoggedInstituteUUID} from 'redux/modules/auth';

/**
 * ROP institution UUIDs from Redux instance (dashboard hydration or license).
 */
export function ropInstitutionUuidListFromState(state) {
  const data = (state.instance && state.instance.data) || {};
  const {institution_uuid_list: list, institution_id} = data;
  if (Array.isArray(list) && list.length) {
    return list;
  }
  return institution_id ? [institution_id] : [];
}

function loadedRopInstitutionUuidListFromState(state) {
  const data = (state.instance && state.instance.data) || {};
  const {institution_uuid_list: list} = data;
  return Array.isArray(list) && list.length ? list : [];
}

export function resolveRopInstitutionUuidList(dispatch, getState, token) {
  const data = (getState().instance && getState().instance.data) || {};
  const institutionId = data.institution_id || getLoggedInstituteUUID(getState);
  const fallbackSingleTenant = institutionId ? [institutionId] : [];

  const loadedList = loadedRopInstitutionUuidListFromState(getState());
  if (loadedList.length) {
    return Promise.resolve(loadedList);
  }

  if (!institutionId || !token) {
    return Promise.resolve(fallbackSingleTenant);
  }

  const url =
    `${API.administration.rop_institution_uuids}?institution_uuid=` +
    encodeURIComponent(institutionId);
  return fetch(url, {
    method: 'GET',
    cache: 'default',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })
    .then(response => (response.ok ? response.json() : {}))
    .then(json => {
      const list = Array.isArray(json.institution_uuid_list)
        ? json.institution_uuid_list
        : [];
      if (list.length) {
        dispatch(mergeInstanceData({institution_uuid_list: list}));
        return list;
      }
      return fallbackSingleTenant;
    })
    .catch(err => {
      console.log(err);
      return fallbackSingleTenant;
    });
}

/**
 * Append repeated institution_uuid_list query params when ROP isolation flag is on.
 * Pass ropList from resolveRopInstitutionUuidList() so list/search URLs match metrics.
 */
export function appendRopInstitutionUuidListParams(
  url,
  getState,
  ropListOverride = null
) {
  let uuids = [];
  if (Array.isArray(ropListOverride) && ropListOverride.length) {
    uuids = ropListOverride;
  } else if (selectHasCapability('rop_talent_isolation')(getState())) {
    uuids = ropInstitutionUuidListFromState(getState());
  }
  if (!uuids.length) {
    return url;
  }
  let out = url;
  uuids.forEach(uuid => {
    out += `&institution_uuid_list=${encodeURIComponent(uuid)}`;
  });
  return out;
}

/** Recruitment Insights: always scope to ROP-connected institutes (no global). */
export function appendRecruitmentInstitutionUuidListParams(url, ropList) {
  if (!Array.isArray(ropList) || !ropList.length) {
    return url;
  }
  let out = url;
  ropList.forEach(uuid => {
    out += `&institution_uuid_list=${encodeURIComponent(uuid)}`;
  });
  return out;
}
